import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import useWindowSize from "../../../../hooks/useWindowSize";

const NutritionHeader = ({
  viewMode,
  handleViewModeChange,
  comesFromBodyComp,
}) => {
  const { t } = useTranslation("athlete-portal");
  const { innerWidth } = useWindowSize();
  const [ismaximized, setIsMaximized] = useState(false);
  const toggleMaxScreenWidth = () => {
    setIsMaximized(!ismaximized);
    const main = document.querySelector("main");
    main.classList.toggle("maximized");
  };

  return (
    <header>
      <hgroup className="flex gap-1">
        {comesFromBodyComp && (
          <SvgIcon
            classNames="cursor-pointer "
            onClickFn={() => {
              history.back();
            }}
            src={"/img/new-icons/back-button.svg"}
          />
        )}
        <button
          data-button-type={viewMode === "progress" ? "outline" : "secondary"}
          onClick={() => handleViewModeChange("progress")}
        >
          <span>{t("nutritionPage.header.progress")}</span>
        </button>
        {/* Not `viewMode === "plans"` — Nutrition.js itself treats anything
            that isn't "progress" as Plans (`viewMode === "progress" ? ... :
            ...`), e.g. the meal-planner's back button returns here with
            tabView="meal-plans-tab" (shared with the all-templates page's
            own tab state), not "plans". Matching that same `!== "progress"`
            check keeps this highlight correct for every value that actually
            renders Plans, instead of special-casing one more string. */}
        <button
          data-button-type={viewMode !== "progress" ? "outline" : "secondary"}
          onClick={() => handleViewModeChange("plans")}
        >
          <span>{t("nutritionPage.header.plans")}</span>
        </button>
      </hgroup>
      {innerWidth > 1600 && (
        <SvgIcon
          src={
            ismaximized
              ? "/img/new-icons/DirectLeft.svg"
              : "/img/new-icons/maximize.svg"
          }
          classNames="opacity-50 hover:opacity-100 cursor-pointer"
          onClickFn={toggleMaxScreenWidth}
        />
      )}
    </header>
  );
};

export default NutritionHeader;
